export default function (idServerRedirectUri) {
    const token = getToken();

    if (token) {
        localStorage.removeItem('redirectToLogin');
    } else {
        // redirect to idserver if the token couldn't be found
        localStorage.removeItem('token');

        redirectToIdServer();
    }

    this.$get = function () {
        return token;
    };

    /* --- */

    function getToken() {
        // extract the token from the url
        let token = extractTokenFromUrl();

        if (token) {
            localStorage.setItem('token', token);
        }

        // get it from localStorage
        token = localStorage.getItem('token');

        return token;
    }

    function extractTokenFromUrl() {
        const hash = window.location.hash.substr(1);
        const result = hash.split('&').reduce((r, item) => {
            const parts = item.split('=');
            r[parts[0]] = parts[1];
            return r;
        }, {});

        if (!result.error) {
            return result.access_token;
        }
    }

    function checkIfIpRestricted() {
        return fetch('/api/health', {
            credentials: 'same-origin',
            method: 'GET'
        })
            .then(response => {
                return response.status === 403;
            })
            .catch(() => {
                // If fetch fails, assume not IP restricted to allow normal flow
                return false;
            });
    }

    function redirectToIdServer() {
        checkIfIpRestricted().then(isBlocked => {
            if (isBlocked) {
                localStorage.removeItem('redirectToLogin');
                window.location.replace('/#/noaccess');
                return;
            }
            const authorizationUrl = '/sts/connect/authorize';
            const clientId = 'basicapp';
            const redirectUri = window.location.origin + '/';
            const responseType = 'token';
            const scope = 'api1';
            const state = `${ Date.now() }${ Math.random() }`;

            const urlParams = [
                `client_id=${ encodeURI(clientId) }`,
                `redirect_uri=${ encodeURI(redirectUri) }`,
                `response_type=${ encodeURI(responseType) }`,
                `scope=${ encodeURI(scope) }`,
                `state=${ encodeURI(state) }`
            ].join('&');

            window.location.href = `${ authorizationUrl }?${ urlParams }`;
        });
    }
}



// WEBPACK FOOTER //
// ./Client/app/common/services/authorizationToken.js